var React = require('react');

function SDCMore18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"cx":"3.5","cy":"8.75","r":"1.25","fill":"var(--iconFill, #464646)","key":0}),React.createElement("circle",{"cx":"9","cy":"8.75","r":"1.25","fill":"var(--iconFill, #464646)","key":1}),React.createElement("circle",{"cx":"14.5","cy":"8.75","r":"1.25","fill":"var(--iconFill, #464646)","key":2})]));
}

SDCMore18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCMore18N;

SDCMore18N.default = SDCMore18N;
